import company from '@/api/company'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return company.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return company.store(data)
  },
  update(context, data) {
    return company.update(data)
  },
  uploadLogo(context, data) {
    return company.uploadfile(data)
  },
  // readLogo(context, id) {
  //   return company.readLogfile(id)
  // },
  destroy(context, id) {
    return company.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      console.log('edit no data set')
      let response = await company.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
